import moment from "moment-timezone";
import { covertTimeSatmp } from "../services/trackerServices.js";
import { validateTimeFormat } from "./cardBodyUiHelpers.js";

/**
 * Time Display Helpers for CardBody Component
 * Contains functions for displaying and formatting time
 */

/**
 * Show and edit time based on duration input
 * @param {Object} params - Parameters for time display
 * @returns {void}
 */
export const timeShowEdit = ({
  timeSec,
  dateEdit,
  startTimeEdit,
  setUDuration,
  setUFormatedTime,
  setUFormatedTimeError,
  setEndTimeEdit,
  setUStartTimeError,
  setUEndTimeError,
}) => {
  if (validateTimeFormat(timeSec)) {
    const timeString = timeSec;
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const totalSeconds =
      parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
    const date = dateEdit;
    const formattedDates = covertTimeSatmp(
      date,
      startTimeEdit && startTimeEdit.trim()
    );
    const timestampInSeconds = Math.floor(
      new Date(formattedDates).getTime() / 1000
    );
    setUDuration(parseInt(totalSeconds));
    const upcomingTimeInSeconds = parseInt(timestampInSeconds) + parseInt(totalSeconds);
    const upcomingTime = new Date(parseInt(upcomingTimeInSeconds) * 1000);
    const formattedTime = upcomingTime &&
      upcomingTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
        .replace("am", "AM")
        .replace("pm", "PM");
    setUFormatedTimeError(false);
    setEndTimeEdit(formattedTime);
    setUFormatedTimeError(false);
    setUStartTimeError(false);
    setUEndTimeError(false);
  } else {
    setUFormatedTimeError(true);
  }
  setUFormatedTime(timeSec);
};
